import { configureStore } from '@reduxjs/toolkit';
import createReducer from './reducers';
import { api } from '../api';

const reducer = createReducer();
export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
  // devTools: process.env.NODE_ENV !== 'production',
});
